<div (inViewportAction)="onInViewChangeEvent($event)"
  [class.loading]="computing"
  [inViewportOptions]="{ partial: false, threshold: [0,1] }"
  [ngClass]="{'tile-loading' : loadingMenuItem}"
  [title]="getTooltip()"
  class="machine-card"
  inViewport>
  <div (click)="openDefaultItemFromLeftMenu()"
    class="machine-card-header machine-header-clickable">
    <ng-template #trafficTooltip>
      <span [innerHTML]="getTrafficTooltip()"></span>
    </ng-template>
    <div (click)="onOpenStatusEventPage($event);"
      [disableTooltip]="onDisableToolTip()"
      [ngClass]="trafficLightClass"
      [ngbTooltip]="trafficTooltip"
      class="machine-card-icon traffic-light">
      <img [src]="machineIcon" alt="">
    </div>
    <div class="title-wrapper">
      <strong [innerHTML]="machineName" class="title"></strong>
      <span class="subtitle">
        <span [innerHTML]="this.categoryDisplayName"></span>
        &nbsp;|&nbsp;
        @if (machineTagExists()) {
          <span
          [innerHTML]="machine.machineTag"></span>
        }
      </span>
    </div>

    <div class="machine-card-status">
      <div class="d-inline-block" ngbDropdown>
        <button (click)="preventOpeningDefaultItemFromLeftMenu($event)"
          [disabled]="isViewerRole"
          [ngClass]="gatewaysStatusClass"
          [title]="'Connection status'| translate"
          class="btn btn-xs dropdown-no-arrow" id="ddCloudPlug"
          ngbDropdownToggle>
          <i class="fa-solid fa-cloud"></i>
        </button>
        <div (click)="preventOpeningDefaultItemFromLeftMenu($event)" aria-labelledby="ddCloudPlug"
          class="dropdown-connections pt-3 pb-3 pl-3"
          ngbDropdownMenu>
          <div class="dropdown-connections-container pr-3">
            <div class="section-fixed pb-2">
              <h6 class="dropdown-header p-0" translate>Gateways (<span [innerHTML]="gatewaysStatus | translate"></span>)
            </h6>
          </div>
          <ul class="dropdown-list p-0">
            @if (gatewaysStatus === GatewayAggregatedStatusEnum.NO_GATEWAYS) {
              <li
                class="d-flex justify-content-between align-items-center">
                <span class="badge badge-outline badge-info" translate>Realtime information not configured</span>
              </li>
            }
            @for (gateway of gateways; track gateway) {
              <li class="d-flex justify-content-between align-items-center">
                <span [innerHTML]="gateway.name" [title]="gateway.name" class="truncate mr-2"
                style="max-width: 140px;"></span>
                @if (gateway.computedStatus === GatewayStatusEnum.ONLINE) {
                  <span
                  class="badge badge-outline badge-success" translate>Online</span>
                }
                @if (gateway.computedStatus === GatewayStatusEnum.PARTIALLY_DISCONNECTED) {
                  <span
                  class="badge badge-outline badge-warning" translate>Partially disconnected</span>
                }
                @if (gateway.computedStatus === GatewayStatusEnum.OFFLINE_OR_UNKNOWN ||
                  gateway.computedStatus === GatewayStatusEnum.MISSING) {
                  <span
                  class="badge badge-outline badge-danger" translate>Offline or unknown</span>
                }
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <!-- Edit tile, hidden on mobile -->
    @if (isAdminRole|| isSuperAdminRole) {
      <button (click)="onEditMachineTile($event)"
        [title]="'Tile configuration' | translate"
        class="btn btn-xs btn-outline-primary d-none d-md-inline-flex">
        <i class="fa-solid fa-pen"></i>
      </button>
    }

  </div>

</div>
<div class="machine-card-content" title="">
  @if (!gateways && placeholderImage) {
    <div
      class="machine-content-image">
      <img [alt]="'Placeholder'| translate" [src]="placeholderImage">
    </div>
  }

  <!-- No Gateways -->
  @if (gatewaysStatus && gatewaysStatus===GatewayAggregatedStatusEnum.NO_GATEWAYS && !placeholderImage) {
    <div
      class="alert alert-info">
      <span translate>No gateways configured.</span>
    </div>
  }

  <!-- MISCONFIGURATION -->
  @if (gatewaysStatus && gatewaysStatus===GatewayAggregatedStatusEnum.MISCONFIGURATION) {
    <div
      class="alert alert-info">
      <span translate>The machine configuration is missing or is incorrect.</span>
    </div>
  }

  <!-- TILE without any signals -->
  @if (tileHasNoSignalsConfigured) {
    <div class="alert alert-info">
      <span translate>The machine tile configuration is missing or is incorrect.</span>
    </div>
  }

  <!-- Disconnected - Danger Alerts -->
  @if (gatewaysStatus && gatewaysStatus===GatewayAggregatedStatusEnum.DISCONNECTED && !tileHasNoSignalsConfigured) {
    <div
      class="alert alert-danger">
      <span translate>Machine is offline.</span>
    </div>
  }

  <!-- Input Value Missing (data) -->
  @if (isInputValueMissing) {
    <span class="alert alert-info" translate>Input Value Missing</span>
  }

  @if (gatewaysStatus && gatewaysStatus===GatewayAggregatedStatusEnum.PARTIALLY_DISCONNECTED && !hasValuesToDisplay) {
    <div
      class="alert alert-warning">
      <!-- Input Value Missing (connectors) -->
      @if (!gatewaysConnectorsActive) {
        <span translate>Input Value Missing</span>
      }
      <!-- Input Value Missing (evaluation) -->
      @if (gatewaysConnectorsActive && machineStatus===MachineStatusEnum.CANNOTEVALUATE) {
        <span
        translate> Input Value Missing</span>
      }
      @if (gatewaysConnectorsActive &&
        (MACHINE_STATUS_UNAVAILABLE.indexOf(machineStatus)<0) &&
        (!showDate)) {
        <span [innerHTML]="statusChangeTimestamp | date:'mediumTime'">
        </span>
      }
    </div>
  }

  @if (hasValuesToDisplay && gatewaysStatus && gatewaysStatus!=='DISCONNECTED' && !tileHasNoSignalsConfigured) {
    <div
      class="table-values">
      <table>
        @for (row of [0,1,2,3]; track row) {
          <tr>
            @for (col of [0,1]; track col) {
              <td class="values-row">
                <!-- EMPTY CELL PLACEHOLDER-->
                @if (displayedSignalsValues[row][col].signalName ===NONE_SIGNAL_NAME) {
                  <div>
                    <span class="name">&nbsp;</span>
                    <div><span class="value">&nbsp;</span></div>
                  </div>
                }
                @if (displayedSignalsValues[row][col].signalName !== NONE_SIGNAL_NAME) {
                  <div>
                    <!--SIGNAL LABEL-->
                    <span [innerHtml]="displayedSignalsValues[row][col].label"
                      [title]="displayedSignalsValues[row][col].label"
                      class="name d-block">
                    </span>
                    <!--MISSING VALUE SPINNER -->
                    @if (displayedSignalsValues[row][col].isValueMissing) {
                      <div
                        [title]="('Value currently missing'| translate)+ '...'">
                        <em class="fa-solid fa-spinner fa-spin"></em>
                      </div>
                    }
                    @if (!displayedSignalsValues[row][col].isValueMissing) {
                      <div>
                        <span class="value text-monospace">
                          <span [innerHtml]="displayedSignalsValues[row][col].value">
                          </span>
                          @if (displayedSignalsValues[row][col].hasEnhancedDetails) {
                            <span
                              [title]="'Click for details ...' | translate"
                              [autoClose]="'outside'"
                              #popover="ngbPopover"
                              [ngbPopover]="popContent"
                              [popoverTitle]="popTitle"
                              class="fa-solid fa-circle-info status-indicator ml-1"
                              [ngClass]="{'status-indicator-open':popover.isOpen()}"
                              placement="right-top">
                            </span>
                          }
                        </span>
                        <ng-template #popContent>
                          <div [innerHTML]="displayedSignalsValues[row][col].enhancedDetailsBody"></div>
                        </ng-template>
                        <ng-template #popTitle><span [innerHTML]="displayedSignalsValues[row][col].enhancedDetailsTitle"></span>
                      </ng-template>
                    </div>
                  }
                </div>
              }
            </td>
          }
        </tr>
      }
    </table>
  </div>
}
</div>
</div>
